import React from 'react';
import { motion } from 'framer-motion';
import { FaCouch, FaHome, FaChalkboardTeacher } from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <FaCouch className="service-icon" />,
      title: "Dons d'objets",
      description: "Échangez ou récupérez des meubles et objets pour votre logement étudiant"
    },
    {
      icon: <FaHome className="service-icon" />,
      title: "Logement solidaire",
      description: "Trouvez des solutions d'hébergement temporaire entre étudiants"
    },
    {
      icon: <FaChalkboardTeacher className="service-icon" />,
      title: "Mentorat",
      description: "Bénéficiez de l'expérience d'anciens étudiants internationaux"
    }
  ];

  return (
    <section className="services-section">
      <div className="services-container">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="services-title"
        >
          Nos services clés
        </motion.h2>
        
        <div className="services-cards">
          {services.map((service, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="service-card"
            >
              <div className="service-icon-container">
                {service.icon}
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              {/* Si vous voulez ajouter un lien plus tard : */}
              {/* <div className="service-link">
                <Link to="/">En savoir plus <FiArrowRight /></Link>
              </div> */}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;